export const HIDDEN_PRICING_COLUMNS_STORAGE_KEY = 'hpDispatchPricingHiddenColumns'
export const PRICING_COLUMNS_DEFAULTS_STORAGE_KEY = 'hpDispatchPricingHiddenColumnsDefaultsVersion'
export const DEFAULT_HIDDEN_PRICING_COLUMNS = ['commissionInterval', 'history']

// Login clears session data in several places. Retain only these non-sensitive display preferences.
export const clearLocalStoragePreservingPricingColumns = () => {
  const preferences = []
  try {
    [HIDDEN_PRICING_COLUMNS_STORAGE_KEY, PRICING_COLUMNS_DEFAULTS_STORAGE_KEY].forEach(key => {
      const value = localStorage.getItem(key)
      if (value !== null) preferences.push([key, value])
    })
  } catch (e) {
    // Session cleanup must still run if preferences cannot be read.
  }

  localStorage.clear()

  try {
    preferences.forEach(([key, value]) => localStorage.setItem(key, value))
  } catch (e) {
    // Blocked storage must not prevent login or restore any session credentials.
  }
}
